import React from "react";
import brutusSvg from "./brutus-avatar.svg";
import blockODarkMode from "./block-osu-darkmode.svg";
import blockO from "./block-osu.svg";

export const Brutus = (props = {}) => (
  <img alt="Brutus avatar" {...props} src={brutusSvg} />
);

export const BlockO = (props = {}) => {
  const { darkMode, ...rest } = props;
  return <img alt="block o" {...rest} src={darkMode ? blockODarkMode : blockO} />;
};
